'use client';

import {
  BodyLinkV3 as BodyLink,
  LayoutGrid,
  TypographyRhythm,
  TypographyV3 as Typography,
} from '@jouzen/ecom-components';

const Content = () => {
  return (
    <LayoutGrid>
      <TypographyRhythm className="col-main">
        <Typography variant="h2" Element="h1" className="mb-8">
          Content Use Agreement
        </Typography>

        <Typography>
          We love your image, video or other content and know others will
          benefit from experiencing it. As you consider allowing us to publish
          your content, we want to make sure you know exactly how we intend to
          use it.
        </Typography>

        <Typography>
          You can provide your permission for <strong>Oura</strong> to use your
          content by replying to our social media post (e.g. Instagram,
          Facebook, Twitter or other) with #agree or by uploading the content
          directly. By providing your permission, you represent and warrant that
          you own the content (avatar, text, profile, images and videos) and
          there are no other entities with ownership claims over it. You grant{' '}
          <strong>Oura</strong> a non-exclusive and non-revocable commercial
          right to reproduce the content in any form (including, but not limited
          to, video, internet posting, reproduction, display, email,
          publication, and distribution), either through our own services or
          services provided by third parties, throughout the world in any medium
          now known or later developed and without restriction or limitation.
          You agree that your content may be used by <strong>Oura</strong> or by
          others under the direction of <strong>Oura</strong> to create
          derivative works either alone or in conjunction with sketches,
          cartoons, captions, films, art work, textural matter or other
          photographs. While <strong>Oura</strong> will make commercially
          reasonable efforts to give you credit for your content and provide a
          link back to your content or account, you agree that such credit is
          not mandatory and your permission for us to use your content is not
          contingent upon such credit being given.
        </Typography>

        <Typography>
          You waive any right to inspect and/or approve the finished work
          incorporating the content or the advertising copy that may be used in
          connection therewith or the use of which said finished work may be
          applied. Further, you waive any claims to royalties with regards to
          your content or our finished work.
        </Typography>

        <Typography>
          Last, you agree that if any provision, or any portion of any
          provision, contained herein is determined to be invalid under any
          statute or rule of law, then it shall, to that extent alone, be deemed
          omitted, and the remainder of this Permission to Use Content Agreement
          shall remain in full force and effect. This Permission to Use Content
          Agreement shall be governed by the laws of the state of California.
        </Typography>

        <Typography>
          If you don't agree to these terms, we completely understand and no
          further action is required. We are thrilled to see{' '}
          <strong>Oura</strong> as a part of your page and look forward to
          seeing any new content you post as well.
        </Typography>

        <Typography>
          Thanks again and please email us at{' '}
          <BodyLink
            href="https://support.ouraring.com/hc/en-us/requests/new"
            rel="noopener noreferrer"
            target="_blank"
          >
            https://support.ouraring.com/hc/en-us/requests/new
          </BodyLink>{' '}
          if you have any questions.
        </Typography>
      </TypographyRhythm>
    </LayoutGrid>
  );
};

export default Content;
